import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from '@kyruus/intl';
import { useCrmConnector as useCRM } from '@kyruus/crm-connector-widget';
import Cancel from '@kyruus/react-ikons/Cancel';
import Snackbar, { IconButton as SnackbarIconButton } from '@kyruus/snackbar';
import { MODULES, isModuleEnabled } from 'Common/config';
import { SEARCH_SHUFFLE_TOKEN, saveToken } from 'Common/logging/tokens';
import { InvalidPatientDataAlerts } from '../InvalidPatientDataAlerts';
import { messages } from './messages';

export const CrmConnectorContext = React.createContext();

export const CrmConnectorProvider = connect()(
  injectIntl(function CrmConnectorProvider({
    intl,
    log,
    config,
    machineOptions = {},
    ...props
  }) {
    const crmEnabled = isModuleEnabled(config, MODULES.CRM_INTEGRATION);
    const isBookingEnabled = isModuleEnabled(config, MODULES.DIRECT_BOOK);
    const isReferralEnabled = isModuleEnabled(config, MODULES.REFERRAL);
    const crmConnector = useCRM({
      initialContext: { ...config?.crm, ...config?.referral },
      machineOptions: {
        ...machineOptions,
        actions: {
          ...(machineOptions.actions ? machineOptions.actions : {}),
          onInitialization: (ctx, event) => {
            if (crmEnabled) {
              machineOptions?.actions?.onInitialization?.(ctx, event);
              log?.('crm.integration.initialization.success', ctx.envData);
            }
          },
          onInitializationError: (ctx, event) => {
            if (crmEnabled) {
              machineOptions?.actions?.onInitializationError?.(ctx, event);
              log?.('crm.integration.initialization.error', ctx.envData);
            }
          },
          onPatientReceived: (_, event) => {
            if (event.data?.caseId != null) {
              if (machineOptions.actions.onPatientReceived) {
                machineOptions.actions.onPatientReceived(event.data.caseId);
              }

              saveToken({
                token: SEARCH_SHUFFLE_TOKEN,
                value: event.data.caseId
              });
            }
          }
        }
      }
    });

    const value = {
      enabled: crmEnabled,
      isBookingEnabled,
      isReferralEnabled,
      connector: crmConnector
    };

    return (
      <>
        {crmEnabled && crmConnector.hasErrors() ? (
          <Snackbar
            key={crmConnector.state.context.errors[0].type}
            mode="error"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={
              crmConnector.hasErrors() &&
              crmConnector.state.context.errors[0].displayToUser
            }
            message={intl.formatMessage(
              messages[crmConnector.state.context.errors[0].type]
            )}
            onClose={(_, reason) => {
              if (reason !== 'clickaway') {
                crmConnector.dismissError();
              }
            }}
            action={
              <SnackbarIconButton
                color="inherit"
                onClick={crmConnector.dismissError}
              >
                <Cancel />
              </SnackbarIconButton>
            }
          />
        ) : null}
        {crmEnabled && crmConnector.hasPatientValidationErrors() && (
          <InvalidPatientDataAlerts
            crmConnector={crmConnector}
            isBookingEnabled={isBookingEnabled}
            isReferralEnabled={isReferralEnabled}
          />
        )}
        <CrmConnectorContext.Provider value={value} {...props} />
      </>
    );
  })
);
